class ArtificioSideMenu extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('.nav-hamburger');
      if (trigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(trigger);
      } else if (event.target.closest('[data-al-menu-close]')) this.close();
    }, { capture: true, signal });
    document.addEventListener('keydown', event => {
      if (!this.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); }
      if (event.key !== 'Tab') return;
      const items = Array.from(this.querySelectorAll('a[href], button:not([tabindex="-1"]), summary')).filter(el => el.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }, { signal });
  }
  open(trigger) {
    this.trigger = trigger;
    this.inert = false;
    this.setAttribute('aria-hidden', 'false');
    this.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('al-menu-open');
    this.blocked = Array.from(document.body.children).filter(el => el instanceof HTMLElement && el !== this && !el.inert && !['SCRIPT', 'STYLE', 'LINK'].includes(el.tagName));
    this.blocked.forEach(el => { el.inert = true; });
    this.querySelector('.al-menu__close')?.focus();
  }
  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    this.inert = true;
    document.body.classList.remove('al-menu-open');
    this.blocked?.forEach(el => { el.inert = false; });
    this.trigger?.setAttribute('aria-expanded', 'false');
    this.trigger?.focus();
  }
  disconnectedCallback() { this.close(); this.controller?.abort(); this.controller = null; }
}
if (!customElements.get('al-side-menu')) customElements.define('al-side-menu', ArtificioSideMenu);